import { Grid } from '@mui/material';
import { Datagrid, DateField, FunctionField, List, NumberField, TextField, useRecordContext } from 'react-admin';
import { DataProviderResource } from 'src/constants';
import { OfferOrderStatusChip } from 'src/lib';
import { OfferOversubscription, OfferOversubscriptionDraftOrder } from 'src/models';

import { UpdateOversubscriptionDraftOrderButton } from './UpdateOversubscriptionDraftOrderButton';

export const OfferOversubscriptionDraftOrderList = () => {
  const context = useRecordContext<OfferOversubscription>();

  return (
    <List
      title=' '
      sort={{ field: 'createdAt', order: 'DESC' }}
      resource={DataProviderResource.OfferOversubscriptionDraftOrder}
      exporter={false}
      filter={{ id: context.id }}
      emptyWhileLoading>
      <Datagrid bulkActionButtons={false}>
        <TextField source='id' label='Id' sortable={false} />
        <TextField source='offer.name' label='Offer' sortable={false} />
        <TextField source='actual.accountId' label='Account Id' sortable={false} />
        <FunctionField
          label='Status'
          render={(record: OfferOversubscriptionDraftOrder) => <OfferOrderStatusChip value={record.actual.status} />}
          sortable={false}
        />
        <NumberField
          source={context.status.isCompleted ? 'previous.quantity' : 'actual.quantity'}
          label={context.status.isCompleted ? 'Previous Quantity' : 'Quantity'}
          sortable={false}
        />
        <FunctionField
          label={context.status.isCompleted ? 'Quantity' : 'Draft Quantity'}
          render={(record: OfferOversubscriptionDraftOrder) => {
            return (
              <Grid container>
                <Grid item md={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                  <NumberField label='Quantity' record={record} source={'quantity'} sx={{ marginRight: '1rem' }} />
                  <UpdateOversubscriptionDraftOrderButton record={record} oversubscription={context} />
                </Grid>
              </Grid>
            );
          }}
        />
        <NumberField
          source={context.status.isCompleted ? 'previous.totalCost' : 'actual.totalCost'}
          label={context.status.isCompleted ? 'Previous Total Cost' : 'Total Cost'}
          options={{ style: 'currency', currency: 'USD' }}
          sortable={false}
        />
        <NumberField
          source={'totalCost'}
          label={context.status.isCompleted ? 'Total Cost' : 'Draft Total Cost'}
          options={{ style: 'currency', currency: 'USD' }}
          sortable={false}
        />
        <DateField source='actual.createdAt' label='Created at' sortable={false} />
      </Datagrid>
    </List>
  );
};
